import { createContextQuick } from '@components/quick-context';
import { PersonFormState } from './person.form.types';

export const [PersonFormContext, usePersonFormContext] = createContextQuick<PersonFormState>();
